import { createFileRoute, Navigate, useSearch } from "@tanstack/react-router";

/**
 * Legacy redirect for in-the-wild Slack claim links. The claim flow is now the
 * provider-agnostic `/connector/:name/connection?ref=…` page; old DM'd links of
 * the form `/slack/claim?team=<team>` (and the legacy `t` deep-link param) still
 * arrive, so forward them to the generic page. No UI of its own.
 */
export const Route = createFileRoute("/slack/claim")({
	component: SlackClaimRedirect,
	validateSearch: (search: Record<string, unknown>) => ({
		team: typeof search.team === "string" ? search.team : undefined,
		// `t` is a legacy convenience deep-link param — no longer used to connect
		// (authority is the Slack workspace-admin check). Accepted so old links
		// still validate before the redirect.
		t: typeof search.t === "string" ? search.t : undefined,
	}),
});

function SlackClaimRedirect() {
	const { team } = useSearch({ from: "/slack/claim" });
	return (
		<Navigate
			to="/connector/$name/connection"
			params={{ name: "slack" }}
			search={{ ref: team }}
			replace
		/>
	);
}
